import DashboardLayout, { FilterContext } from "../../../Layouts/Dashboard/dashboard";
import CatalogSearchHandler from "../../../Components/Catalog/catalog-search-handler";
import React, { useMemo, useState } from "react";
import SelectModeSubbarOpener from "../../../Components/Banners/SelectModeBanner/opener";
import WishlistSelectModeBanner from "../../../Components/Banners/WishlistSelectModeBanner";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import FiltersPanel from "../../../Components/Filters/FiltersPanel/filters-panel";
import { DbMetadataFieldInfos } from "../../../Core/Api/Types/db-metadata-field-infos";
import { MetadataFieldValueObjectTypes } from "../../../Core/Api/Types/metadata-field-value-object-types";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";

function CatalogSingle() {
  const [selectedItems, setSelectedItems] = React.useState<DbAssetObjectInfos[]>([]);

  const handleCloseClick = () => {
    setSelectedItems([]);
  };

  const [openSidebar, setOpenSidebar] = useState(true);
  const [openFiltersPanel, setOpenFiltersPanel] = useState(false);
  const [openFiltersPanelLayer, setOpenFiltersPanelLayer] = useState<ObjectLayer | null>(ObjectLayer.Title);
  const [openFiltersPanelType, setOpenFiltersPanelType] = useState(MetadataFieldValueObjectTypes.DbAssetObjectInfos);
  const [openFiltersPanelMetadataFields, setOpenFiltersPanelMetadataFields] = useState<
    DbMetadataFieldInfos[] | undefined
  >(undefined);
  // Todo avoid load users in each page change
  const filterPanel = useMemo(() => {
    return (
      <FiltersPanel
        openSidebar={openSidebar}
        layer={openFiltersPanelLayer}
        type={openFiltersPanelType}
        metadataFieldsOverride={openFiltersPanelMetadataFields}
      />
    );
  }, [openSidebar, openFiltersPanelLayer, openFiltersPanelType, openFiltersPanelMetadataFields]);

  return (
    <FilterContext.Provider
      value={{
        setOpenFiltersPanel,
        setOpenFiltersPanelLayer,
        setOpenFiltersPanelType,
        setOpenFiltersPanelMetadataFields,
        openFiltersPanel,
        openFiltersPanelLayer,
        openFiltersPanelType,
        openFiltersPanelMetadataFields,
      }}
    >
      {filterPanel}
      <DashboardLayout
        withContainer
        setOpenSidebarFallback={setOpenSidebar}
        stickiesVisibleAt={300}
        sxContent={{ px: 2 }}
        Banner={
          <WishlistSelectModeBanner
            items={selectedItems}
            handleCloseClick={handleCloseClick}
            layer={ObjectLayer.Title}
            itemsCanBeShared={false}
          />
        }
      >
        <CatalogSearchHandler selectedItems={selectedItems} setSelectedItems={setSelectedItems} />
        <SelectModeSubbarOpener selectedObjects={selectedItems} />
      </DashboardLayout>
    </FilterContext.Provider>
  );
}

export default CatalogSingle;
